import { Capacitor } from '@capacitor/core'
import { config } from '@/config'

// Contra que backend corre ESTE binario.
//
// Es el primer dato a descartar cuando algo pasa en el AAB de Play y no en el build
// local: el .env con el que se compilo cada uno pudo ser distinto, y la app no lo
// dice en ningun lado visible. Vive aparte del LogTracker porque el menu de
// diagnostico tambien lo copia, sin que el tracker este encendido.

/** Una linea, para encabezar la lista de peticiones. */
export function envSummary () {
  return `${config('app.env')} | ${config('gql.url')}`
}

/** Bloque completo, para pegar en un reporte. */
export function envHeader () {
  return [
    `app: ${config('app.name')} v${config('app.version')} (env ${config('app.env')}, state ${config('app.state')})`,
    `api.url: ${config('api.url')}`,
    `gql.url: ${config('gql.url')}`,
    `plataforma: ${Capacitor.getPlatform()} | online: ${navigator.onLine}`,
    `ua: ${navigator.userAgent}`
  ].join('\n')
}
